import { JobListDefn } from 'components/JobList';
import { Carousel, CarouselProps } from '../Carousel/Carousel';
import { useJobCarousel } from './hooks/useJobCarousel';
import { JobCarouselCard } from './JobCarouselCard';

export interface JobCarouselProps {
    onSelectChange?: CarouselProps<JobListDefn>['onSelectChange'];
}

export const JobCarousel = ({
    onSelectChange,
}: JobCarouselProps): JSX.Element => {
    const { jobs } = useJobCarousel();
    return (
        <Carousel
            render={(c) => <JobCarouselCard key={c.id} content={c} />}
            content={jobs}
            onSelectChange={onSelectChange}
        />
    );
};
